interface Params {
  price: number;
}

/**
 * Returns number of decimal digits for different currencies
 */
export function priceGetMaxFractionDigits(params: Params): number {
  const { price } = params;
  if (price > 1) return 2;
  if (price > 0.1) return 4;
  if (price > 0.01) return 6;
  if (price > 0.001) return 7;
  if (price > 0.00000001) return 8;
  if (price < 0.00000001) return 12;

  return 2;
}
